export default "__VITE_ASSET__BIUX_7g4__"